import { ReactNode } from 'react'

import styles from './EmptyState.module.scss'

export function EmptyState({
  message,
  children,
  id,
}: {
  message: ReactNode
  children?: ReactNode
  id?: string
}) {
  return (
    <div className={styles.root} data-testid="empty-state" id={id}>
      <p className={styles.message}>{message}</p>
      {children}
    </div>
  )
}
